import React from 'react';
type PhotoBannerProps = {
  src: string;
  caption: string;
};
export function PhotoBanner({
  src,
  caption
}: PhotoBannerProps) {
  return <figure className="w-full bg-paper" data-id="element-60" data-mp="1jynnon7czpax">
      <img src={src} alt={caption} className="block h-auto w-full object-cover" loading="lazy" data-id="element-61" data-mp="1ylqnx1n2gc1y" />
      <figcaption className="mx-auto max-w-6xl px-4 py-3 text-center text-sm text-muted sm:px-6" data-id="element-62" data-mp="1tvk1n8g113mv">
        {caption}
      </figcaption>
    </figure>;
}